// @flow

import * as api from '../api/jackpotSlots';
import {
  API_CALL,
  RESET_JACKPOT_SLOTS,
  STOP_JACKPOT_SLOTS_SPINNING
} from '../constants/actionTypes';
import { JACKPOT_SLOTS, JACKPOT_SLOTS_GET_WINNERS } from '../constants/apiTypes';

export function postSpin() {
  return {
    type: API_CALL,
    api: JACKPOT_SLOTS,
    request: api.postSpin()
  };
}

export function getWinners() {
  return {
    type: API_CALL,
    api: JACKPOT_SLOTS_GET_WINNERS,
    request: api.getWinners()
  };
}

export function stopSpinning() {
  return {
    type: STOP_JACKPOT_SLOTS_SPINNING
  };
}

export function resetJackpotSlots() {
  return {
    type: RESET_JACKPOT_SLOTS
  };
}
